import { render, staticRenderFns } from "./tarifa-calculador-v3.vue?vue&type=template&id=5660ad2b&scoped=true"
import script from "./tarifa-calculador-v3.vue?vue&type=script&lang=js"
export * from "./tarifa-calculador-v3.vue?vue&type=script&lang=js"
import style0 from "./tarifa-calculador-v3.vue?vue&type=style&index=0&id=5660ad2b&prod&scoped=true&lang=css"
import style1 from "./tarifa-calculador-v3.vue?vue&type=style&index=1&id=5660ad2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5660ad2b",
  null
  
)

export default component.exports